module.exports = __webpack_public_path__ + "img/vartext3en.b91720a4.svg";